/* tslint:disable */
/* eslint-disable */
export enum WorkProjectRoofTypesEnum {
  PitchedRoof = 'pitched_roof',
  FlatRoof = 'flat_roof'
}
